import { Link } from 'react-router-dom';
import { fundSectionHref, fundSections, home, routes } from '../../models/content';
import V2CtaDark from '../components/V2CtaDark';

export default function V2HomePage() {
  return (
    <>
      <main>
        <section className="home-hero">
          <div className="wrap">
            <span className="v2-badge">
              <span className="dot" />
              {home.badge}
            </span>

            <h1>
              {home.headlineLines.map((line, idx) => (
                <span key={idx}>
                  {Array.isArray(line)
                    ? line.map((part, i) =>
                        typeof part === 'string' ? (
                          <span key={i}>{part}</span>
                        ) : (
                          <span key={i} className="it">
                            {part.it}
                          </span>
                        )
                      )
                    : null}
                  <br />
                </span>
              ))}
            </h1>

            <p className="sub">{home.subhead}</p>

            <div className="cta-row">
              <Link
                to={routes.fund}
                className="btn btn-primary btn-lg"
                aria-label="Know more about Capri Stressed Assets Fund"
              >
                Know More <span aria-hidden="true">→</span>
              </Link>
              <Link to={routes.contact} className="btn btn-ghost btn-lg">
                Get in Touch
              </Link>
            </div>

            <div className="stat-strip">
              {home.stats.map((s) => (
                <div className="item" key={s.label}>
                  <div className="v">
                    {s.value}
                    {s.valueUnit ? <span className="unit">{s.valueUnit}</span> : null}
                    {s.valueEm ? <span className="em">{s.valueEm}</span> : null}
                    {s.suffix ?? ''}
                  </div>
                  {s.valueSub ? <div className="stat-date">{s.valueSub}</div> : null}
                  <div className="l">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="strategy-v2">
          <div className="wrap">
            <div className="head">
              <h2 className="kicker">Our Strategy</h2>
              <div className="strategy-lede">
                Our investment thesis envisages participation in the <span className="it">value-creation process</span>{' '}
                while preserving the invested capital.
              </div>
            </div>
            <div className="pillars">
              <article className="pillar">
                <span className="bg-num">01</span>
                <span className="eyebrow">Pillar 01</span>
                <h3 id="pillar-operate">How Do We Operate?</h3>
                <Link
                  id="know-more-operate"
                  to={fundSectionHref(fundSections.operate)}
                  className="more"
                  aria-labelledby="know-more-operate pillar-operate"
                >
                  Know More <span aria-hidden="true">→</span>
                </Link>
              </article>
              <article className="pillar">
                <span className="bg-num">02</span>
                <span className="eyebrow">Pillar 02</span>
                <h3 id="pillar-contribute">How Do We Contribute?</h3>
                <Link
                  id="know-more-contribute"
                  to={fundSectionHref(fundSections.contribute)}
                  className="more"
                  aria-labelledby="know-more-contribute pillar-contribute"
                >
                  Know More <span aria-hidden="true">→</span>
                </Link>
              </article>
              <article className="pillar">
                <span className="bg-num">03</span>
                <span className="eyebrow">Pillar 03</span>
                <h3 id="pillar-add-value">How Do We Add Value to Our Investors?</h3>
                <Link
                  id="know-more-add-value"
                  to={fundSectionHref(fundSections.addValue)}
                  className="more"
                  aria-labelledby="know-more-add-value pillar-add-value"
                >
                  Know More <span aria-hidden="true">→</span>
                </Link>
              </article>
            </div>
          </div>
        </section>
      </main>

      <V2CtaDark />
    </>
  );
}

